import { render, staticRenderFns } from "./BetsAndCommissionMonthlyBarGraph.vue?vue&type=template&id=2b374364&"
import script from "./BetsAndCommissionMonthlyBarGraph.vue?vue&type=script&lang=js&"
export * from "./BetsAndCommissionMonthlyBarGraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports